import { Result } from '@standardnotes/domain-core';
import { Platform } from '@standardnotes/models';
export class IsAndroid {
    constructor(platform) {
        this.platform = platform;
    }
    execute() {
        return Result.ok(this.platform === Platform.Android);
    }
}
